export default __webpack_public_path__ + "static/media/security-monitoring.e384df58.png";